<template>
<div class="chapter">
<div class="inner_page">
<section class="epigraph" epub:type="epigraph">
<blockquote class="hanging_indent bq">
<p class="no_header firstInSection">Children of the martyr-race,</p>
<p>Whether free or fettered,</p>
<p>Wake the echoes of the songs,</p>
<p>Where ye may be scattered.</p>
<p>Yours the message cheering,</p>
<p>That the time is nearing,</p>
<p>Which will see all men free,</p>
<p>Tyrants disappearing.</p>
</blockquote>
<p class="right firstInSection">From a <em>Chanukah</em> hymn</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?07021390